import { Maybe } from '@/utils/types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'brand_landing'
type ItemType = 'ContentEpisode'

/**
 * Interaction builder for episodes in the episodes tab
 * Used for tracking user interactions with episode content
 */
export class EpisodesTabItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<ItemType>; attribution: unknown }) {
    super(item)
  }
}
